import axiosCall from './interceptor';
import URL from '../helper';

export const listofServices = async data => {
  const url = `${URL.BASE_URL}storageSettings`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const postServicedata = async data => {
  const url = `${URL.BASE_URL}storageSettings`;
  let response = await axiosCall('post', url, data);
  return response.data;
};
